import React from 'react'
import TestimonialBody from '../../TestimonialBody';
import TestimonialHead from '../../TestimonialHead';

const   Testimoniall = () => {
  return (
    <>
      <div class="preloader" style={{display: "none"}}>
        <div class="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className='main mt-0' >
       
       <TestimonialHead/>
       <TestimonialBody/>
      </div>
    </>
  )
}

export default Testimoniall;
